import { clientEndpoint } from 'src/constants'

import logo from 'src/public/img/logo.png'

const navBarTopItems = [
  {
    link: `${clientEndpoint}/webinar`,
    text: 'Вебинары',
    icon: 'webinar'
  },
  {
    link: `${clientEndpoint}/article`,
    text: 'Статьи',
    icon: 'article'
  },
  {
    link: `${clientEndpoint}/video`,
    text: 'Видео',
    icon: 'video'
  },
  {
    link: `${clientEndpoint}/found-bug`,
    text: 'Нашли ошибку?',
    icon: 'error'
  }
]

export { navBarTopItems, logo }
